import { readLastOrderForBusiness } from '@/lib/localLastOrder';

const SERVICE_LABELS = {
  delivery: 'Delivery',
  retiro: 'Retiro en local',
  pickup: 'Retiro en local',
  mesa: 'Mesa',
};

/** Último pedido: API del cliente si existe; si no, el guardado en el dispositivo. */
export function getOrderToRepeat(businessId, apiLastOrder) {
  const localOrder = readLastOrderForBusiness(businessId);
  const apiOrder = apiLastOrder?.items?.length > 0 ? apiLastOrder : null;
  if (apiOrder) return apiOrder;
  return localOrder?.items?.length ? localOrder : null;
}

/** Convierte ítems del pedido anterior a líneas tipo carrito (upsell). */
export function orderItemsToCartLines(order) {
  if (!order?.items?.length) return [];
  return order.items.map((item, index) => ({
    id: `repeat-line-${index}`,
    product:
      item.product && typeof item.product === 'object'
        ? item.product
        : {
            id: item.product_id || item.id,
            name: item.name || 'Producto',
            price: Number(item.price) || 0,
          },
    quantity: Number(item.quantity) || 1,
  }));
}

export function formatOrderSummaryText(order) {
  if (!order?.items?.length) return '📦 Tu último pedido';
  const serviceKey = order.serviceType || order.service_type;
  let message = '📦 Tu último pedido\n\n';
  if (serviceKey && SERVICE_LABELS[serviceKey]) {
    message += `${SERVICE_LABELS[serviceKey]}\n\n`;
  }
  order.items.forEach((item, index) => {
    const qty = Number(item.quantity) || 1;
    const name = item.product?.name || item.name || 'Producto';
    const unit = Number(item.price ?? item.product?.price) || 0;
    message += `${index + 1}. ${name} x${qty}\n`;
    message += `   $${(unit * qty).toLocaleString('es-CL')}\n\n`;
  });
  const totalNum = Number(order.total);
  message += `💵 Total: $${(Number.isFinite(totalNum) ? totalNum : 0).toLocaleString('es-CL')}`;
  return message;
}

/** Una línea para la tarjeta de bienvenida. */
export function formatLastOrderShortLabel(order) {
  if (!order?.items?.length) return 'Repetir mi último pedido';
  const names = order.items
    .slice(0, 2)
    .map((i) => i.product?.name || i.name)
    .filter(Boolean);
  const more = order.items.length > 2 ? ` +${order.items.length - 2}` : '';
  const total = Number(order.total) || 0;
  const itemsBit = names.length ? `${names.join(', ')}${more}` : `${order.items.length} productos`;
  return `Repetir: ${itemsBit} · $${total.toLocaleString('es-CL')}`;
}

/** Copia ítems del pedido anterior al carrito. */
export function loadOrderIntoCart(order, addToCart, businessId, options = {}) {
  if (!order?.items?.length || typeof addToCart !== 'function') return;
  const cartOpts = { businessId, ...options };
  order.items.forEach((item) => {
    if (item.product && typeof item.product === 'object') {
      addToCart(
        item.product,
        item.addOns || [],
        item.removedIngredients || [],
        Number(item.quantity) || 1,
        cartOpts,
      );
    } else {
      const pid = item.product_id || item.id;
      const rawAddons = item.add_ons || item.addOns || [];
      const addOns = rawAddons.map((a) =>
        typeof a === 'object' && a !== null
          ? {
              name: a.name || '',
              price: Number(a.price) || 0,
              quantity: Number(a.quantity) || 1,
            }
          : a,
      );
      addToCart(
        {
          id: pid,
          name: item.name || 'Producto',
          price: Number(item.price) || 0,
          final_price: Number(item.price) || 0,
        },
        addOns,
        item.removed_ingredients || item.removedIngredients || [],
        Number(item.quantity) || 1,
        cartOpts,
      );
    }
  });
}
